import { getPortfolioAccountsApi, getPortfolioCashAPI, getPortfolioCreditFacilityAPI, getPortfolioCurrencyAPI, getPortfolioDetailAPI, getPortfolioDiscretionaryStatusAPI, getPortfolioExpenseAPI, getPortfolioListAPI, getPortfolioMangerAPI, getPortfolioTaxStatusAPI, getPortfolioTypeAPI, getPortfolioCashAccounts, getPortfolioNonCashAccounts} from "../../config/apiConfig"
import {
    FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS, FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE, FETCH_PORTFOLIO_CASH_BEGIN, FETCH_PORTFOLIO_CASH_FAILURE, FETCH_PORTFOLIO_CASH_SUCCESS, FETCH_PORTFOLIO_CREDITFACILITY_BEGIN, FETCH_PORTFOLIO_CREDITFACILITY_FAILURE, FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS,
    FETCH_PORTFOLIO_CURRENCY_BEGIN, FETCH_PORTFOLIO_CURRENCY_FAILURE, FETCH_PORTFOLIO_CURRENCY_SUCCESS, FETCH_PORTFOLIO_DETAIL_BEGIN, FETCH_PORTFOLIO_DETAIL_FAILURE, FETCH_PORTFOLIO_DETAIL_SUCCESS,
    FETCH_PORTFOLIO_DISCRETIONARYSTATUS_BEGIN, FETCH_PORTFOLIO_DISCRETIONARYSTATUS_FAILURE, FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS, FETCH_PORTFOLIO_EXPENSE_BEGIN, FETCH_PORTFOLIO_EXPENSE_FAILURE, FETCH_PORTFOLIO_EXPENSE_SUCCESS,
    FETCH_PORTFOLIO_LIST_BEGIN, FETCH_PORTFOLIO_LIST_FAILURE, FETCH_PORTFOLIO_LIST_SUCCESS, FETCH_PORTFOLIO_MANAGER_BEGIN, FETCH_PORTFOLIO_MANAGER_FAILURE, FETCH_PORTFOLIO_MANAGER_SUCCESS, FETCH_PORTFOLIO_TAXSTATUS_BEGIN, FETCH_PORTFOLIO_TAXSTATUS_FAILURE,
    FETCH_PORTFOLIO_TAXSTATUS_SUCCESS, FETCH_PORTFOLIO_TYPE_BEGIN,
    FETCH_PORTFOLIO_TYPE_FAILURE, FETCH_PORTFOLIO_TYPE_SUCCESS,
    FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS,
    FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE, FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN, FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS,
    FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE
} from "../constants/portfolio";
import { sbaAxios } from "../utils/sbaAxios";
import { updateEntity } from "../CommonAPI";



// Action to Get list of available tax entities for the portfolios
export const getPortfolioAccountListAction=(searchTerm)=>{
    return (dispatch) => {
        dispatch(fetchPortfolioAccountListBegin());
        let  getPortfolioAccount=getPortfolioAccountsApi
        if(searchTerm)
        {
            getPortfolioAccount=getPortfolioAccountsApi+"?searchText="+searchTerm;
        }
        sbaAxios({url:getPortfolioAccount})       
        .then((repos) => {
          const AccountList = repos;
          dispatch(fetchPortfolioAccountListSuccess(AccountList));
          return AccountList;
        })
        .catch((error) => dispatch(fetchPortfolioAccountListFailure(error)));
    };
};
const fetchPortfolioAccountListBegin = () => ({
    type: FETCH_PORTFOLIO_ACCOUNT_LIST_BEGIN,
});
const fetchPortfolioAccountListSuccess = (PortfolioAccountList) => ( {
    type: FETCH_PORTFOLIO_ACCOUNT_LIST_SUCCESS,
    payload: { PortfolioAccountList },
});
const fetchPortfolioAccountListFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_ACCOUNT_LIST_FAILURE,
    payload: { errorMessage }
});



// Action TO Get Portfolio List By searchTerm or search Term can be null to get all portfolio
export const getPortFolioListAction=(searchTerm)=>{
    return (dispatch) => {
        dispatch(fetchPortfolioListBegin());
        let getPortFolio=getPortfolioListAPI;
        if(searchTerm)
        {
            getPortFolio=getPortFolio+"?searchText="+searchTerm;
        }
        sbaAxios({url:getPortFolio})       
        .then((repos) => {
          const PortfolioList = repos;
          dispatch(fetchPortfolioListSuccess(PortfolioList));
          return PortfolioList;
        })
        .catch((error) => dispatch(fetchPortfolioListFailure(error)));
    };
};
const fetchPortfolioListBegin = () => ({
    type: FETCH_PORTFOLIO_LIST_BEGIN,
});
const fetchPortfolioListSuccess = (portfolioList) => ( {
    type: FETCH_PORTFOLIO_LIST_SUCCESS,
    payload: { portfolioList },
});
const fetchPortfolioListFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_LIST_FAILURE,
    payload: { errorMessage }
});

// Action to Get Portfolio Detail by ID
export const getPortFolioDetailAction=(Id)=>{
    return (dispatch) => {
        dispatch(fetchPortfolioDetailBegin());
        sbaAxios({url:`${getPortfolioDetailAPI}${Id}`})       
        .then((repos) => {
          const Portfolio = repos;
          dispatch(fetchPortfolioDetailSuccess(Portfolio));
          updateEntity("PortfolioId",Id);
          return Portfolio;
        })
        .catch((error) => dispatch(fetchPortfolioDetailFailure(error)));
    };
};
const fetchPortfolioDetailBegin = () => ({
    type: FETCH_PORTFOLIO_DETAIL_BEGIN,
});
const fetchPortfolioDetailSuccess = (Portfolio) => (
   {
    type: FETCH_PORTFOLIO_DETAIL_SUCCESS,
    payload: { Portfolio },
});
const fetchPortfolioDetailFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_DETAIL_FAILURE,
    payload: { errorMessage }
}); 


//Action to get Portfolio Type 
export const getPortFolioTypeAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioTypeBegin());
        sbaAxios({url:`${getPortfolioTypeAPI}`})       
        .then((repos) => {
          const Type = repos;
          dispatch(fetchPortfolioTypeSuccess(Type));
          return Type;
        })
        .catch((error) => dispatch(fetchPortfolioTypeFailure(error)));
    };
};
const fetchPortfolioTypeBegin = () => ({
    type: FETCH_PORTFOLIO_TYPE_BEGIN,
});
const fetchPortfolioTypeSuccess = (Type) => ( {
    type: FETCH_PORTFOLIO_TYPE_SUCCESS,
    payload: { Type },
});
const fetchPortfolioTypeFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_TYPE_FAILURE,
    payload: { errorMessage }
}); 


// Action to Get Portfolio Currency

export const getPortFolioCurrencyAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioCurrencyBegin());
        sbaAxios({url:`${getPortfolioCurrencyAPI}`})       
        .then((repos) => {
          const currency = repos;
          dispatch(fetchPortfolioCurrencySuccess(currency));
          return currency;
        })
        .catch((error) => dispatch(fetchPortfolioCurrencyFailure(error)));
    };
};
const fetchPortfolioCurrencyBegin = () => ({
    type: FETCH_PORTFOLIO_CURRENCY_BEGIN,
});
const fetchPortfolioCurrencySuccess = (Currency) => ( {
    type: FETCH_PORTFOLIO_CURRENCY_SUCCESS,
    payload: { Currency },
});
const fetchPortfolioCurrencyFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_CURRENCY_FAILURE,
    payload: { errorMessage }
}); 


// Action to Get Portfolio Cash

export const getPortFolioCashAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioCashBegin());
        sbaAxios({url:`${getPortfolioCashAPI}`})       
        .then((repos) => {
          const cash = repos;
          dispatch(fetchPortfolioCashSuccess(cash));
          return cash;
        })
        .catch((error) => dispatch(fetchPortfolioCashFailure(error)));
    };
};
const fetchPortfolioCashBegin = () => ({
    type: FETCH_PORTFOLIO_CASH_BEGIN,
});
const fetchPortfolioCashSuccess = (Cash) => ( {
    type: FETCH_PORTFOLIO_CASH_SUCCESS,
    payload: { Cash },
});
const fetchPortfolioCashFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_CASH_FAILURE,
    payload: { errorMessage }
}); 

// Action to get Portfolio Expense

export const getPortFolioExpenseAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioExpenseBegin());
        sbaAxios({url:`${getPortfolioExpenseAPI}`})       
        .then((repos) => {
          const Expense = repos;
          dispatch(fetchPortfolioExpenseSuccess(Expense));
          return Expense;
        })
        .catch((error) => dispatch(fetchPortfolioExpenseFailure(error)));
    };
};
const fetchPortfolioExpenseBegin = () => ({
    type: FETCH_PORTFOLIO_EXPENSE_BEGIN,
});
const fetchPortfolioExpenseSuccess = (Expense) => ( {
    type: FETCH_PORTFOLIO_EXPENSE_SUCCESS,
    payload: { Expense },
});
const fetchPortfolioExpenseFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_EXPENSE_FAILURE,
    payload: { errorMessage }
});

// Action to Get Credidd Facility
export const getPortFolioCreditFacilityAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioCreditFacilityBegin());
        sbaAxios({url:`${getPortfolioCreditFacilityAPI}`})       
        .then((repos) => {
          const CF = repos;
          dispatch(fetchPortfolioCreditFacilitySuccess(CF));
          return CF;
        })
        .catch((error) => dispatch(fetchPortfolioCreditfacilityFailure(error)));
    };
};
const fetchPortfolioCreditFacilityBegin = () => ({
    type: FETCH_PORTFOLIO_CREDITFACILITY_BEGIN,
});
const fetchPortfolioCreditFacilitySuccess = (CreditFacility) => ( {
    type: FETCH_PORTFOLIO_CREDITFACILITY_SUCCESS,
    payload: { CreditFacility },
});
const fetchPortfolioCreditfacilityFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_CREDITFACILITY_FAILURE,
    payload: { errorMessage }
});


// Action to Get Portfolio Manger
export const getPortFolioManagerAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioManagerBegin());
        sbaAxios({url:`${getPortfolioMangerAPI}`})       
        .then((repos) => {
          const Manager = repos;
          dispatch(fetchPortfolioManagerSuccess(Manager));
          return Manager;
        })
        .catch((error) => dispatch(fetchPortfolioManagerFailure(error)));
    };
};
const fetchPortfolioManagerBegin = () => ({
    type: FETCH_PORTFOLIO_MANAGER_BEGIN,
});
const fetchPortfolioManagerSuccess = (Manager) => ( {
    type: FETCH_PORTFOLIO_MANAGER_SUCCESS,
    payload: { Manager },
});
const fetchPortfolioManagerFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_MANAGER_FAILURE,
    payload: { errorMessage }
});

// Action to Get Portfolio TaxStatus
export const getPortFolioTaxStatusAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioTaxStatusBegin());
        sbaAxios({url:`${getPortfolioTaxStatusAPI}`})       
        .then((repos) => {
          const TaxStatus = repos;
          dispatch(fetchPortfolioTaxStatusSuccess(TaxStatus));
          return TaxStatus;
        })
        .catch((error) => dispatch(fetchPortfolioTaxStatusFailure(error)));
    };
};
const fetchPortfolioTaxStatusBegin = () => ({
    type: FETCH_PORTFOLIO_TAXSTATUS_BEGIN,
});
const fetchPortfolioTaxStatusSuccess = (TaxStatus) => ( {
    type: FETCH_PORTFOLIO_TAXSTATUS_SUCCESS,
    payload: { TaxStatus },
});
const fetchPortfolioTaxStatusFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_TAXSTATUS_FAILURE,
    payload: { errorMessage }
});


// Action to Get Portfolio DiscretionaryStatus 

export const getPortFolioDiscretionaryStatusAction=()=>{
    return (dispatch) => {
        dispatch(fetchPortfolioDiscretionaryStatusBegin());
        sbaAxios({url:`${getPortfolioDiscretionaryStatusAPI}`})       
        .then((repos) => {
          const DS = repos;
          dispatch(fetchPortfolioDiscretionaryStatusSuccess(DS));
          return DS;
        })
        .catch((error) => dispatch(fetchPortfolioDiscretionaryStatusFailure(error)));
    };
};
const fetchPortfolioDiscretionaryStatusBegin = () => ({
    type: FETCH_PORTFOLIO_DISCRETIONARYSTATUS_BEGIN,
});
const fetchPortfolioDiscretionaryStatusSuccess = (DiscretionaryStatus) => ( {
    type: FETCH_PORTFOLIO_DISCRETIONARYSTATUS_SUCCESS,
    payload: { DiscretionaryStatus },
});
const fetchPortfolioDiscretionaryStatusFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_DISCRETIONARYSTATUS_FAILURE,
    payload: { errorMessage }
});


// Action to Get Portfolio TO Cash

export const getPortFolioCashAccountAction = (PortfolioId) => {
    return (dispatch) => {
        dispatch(fetchPortfolioCashAccountsBegin());
        sbaAxios({ url: `${getPortfolioCashAccounts}${PortfolioId}` })
            .then((repos) => {
                const TOCash = repos;
                dispatch(fetchPortfolioCashAccountsSuccess(TOCash));
                return TOCash;
            })
            .catch((error) => dispatch(fetchPortfolioCashAccountsFailure(error)));
    };
};
const fetchPortfolioCashAccountsBegin = () => ({
    type: FETCH_PORTFOLIO_TOACCOUNT_LIST_BEGIN,
});
const fetchPortfolioCashAccountsSuccess = (TOCash) => ({
    type: FETCH_PORTFOLIO_TOACCOUNT_LIST_SUCCESS,
    payload: { TOCash },
});
const fetchPortfolioCashAccountsFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_TOACCOUNT_LIST_FAILURE,
    payload: { errorMessage }
});




// Action to Get Portfolio Non Cash Accounts

export const getPortfolioNonCashAccountsAction = (PortfolioId) => {
    return (dispatch) => {
        dispatch(fetchgetPortfolioNonCashAccountsBegin());
        sbaAxios({ url: `${getPortfolioNonCashAccounts}${PortfolioId}` })
            .then((repos) => {
                const Noncashaccounts = repos;
                dispatch(fetchgetPortfolioNonCashAccountsSuccess(Noncashaccounts));
                return Noncashaccounts;
            })
            .catch((error) => dispatch(fetchgetPortfolioNonCashAccountsFailure(error)));
    };
};
const fetchgetPortfolioNonCashAccountsBegin = () => ({
    type: FETCH_PORTFOLIO_NONACCOUNT_LIST_BEGIN,
});
const fetchgetPortfolioNonCashAccountsSuccess = (Noncashaccounts) => ({
    type: FETCH_PORTFOLIO_NONACCOUNT_LIST_SUCCESS,
    payload: { Noncashaccounts },
});
const fetchgetPortfolioNonCashAccountsFailure = (errorMessage) => ({
    type: FETCH_PORTFOLIO_NONACCOUNT_LIST_FAILURE,
    payload: { errorMessage }
});